// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.privacy-page {
  min-height: 100vh;
  padding: 24px 20px 64px;
  color: #17344f;
  background:
    radial-gradient(circle at 12% 5%, rgba(233, 90, 19, 0.1), transparent 28%),
    radial-gradient(circle at 88% 18%, rgba(78, 119, 153, 0.12), transparent 30%),
    #f6f9fb;
}

.privacy-header {
  width: min(1080px, 100%);
  min-height: 76px;
  margin: 0 auto 24px;
  padding: 10px 18px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid rgba(78, 119, 153, 0.16);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 14px 38px rgba(23, 52, 79, 0.08);
  backdrop-filter: blur(18px);
}

.privacy-header img {
  display: block;
  width: 154px;
  height: 46px;
  object-fit: contain;
}

.privacy-home-link {
  padding: 11px 16px;
  border-radius: 12px;
  color: #fff;
  background: #e95a13;
  font-size: 0.88rem;
  font-weight: 800;
  text-decoration: none;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.privacy-home-link:hover {
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 9px 22px rgba(233, 90, 19, 0.25);
}

.privacy-card {
  width: min(960px, 100%);
  margin: 0 auto;
  padding: clamp(28px, 5vw, 64px);
  border: 1px solid rgba(78, 119, 153, 0.14);
  border-radius: 28px;
  background: #fff;
  box-shadow: 0 22px 60px rgba(23, 52, 79, 0.1);
}

.privacy-intro {
  padding-bottom: 32px;
  border-bottom: 1px solid #e1e9ef;
}

.privacy-kicker {
  display: inline-flex;
  margin-bottom: 12px;
  padding: 7px 11px;
  border-radius: 999px;
  color: #c84808;
  background: #fff0e8;
  font-size: 0.72rem;
  font-weight: 900;
  letter-spacing: 0.1em;
  text-transform: uppercase;
}

.privacy-intro h1 {
  margin: 0 0 16px;
  color: #112f49;
  font-size: clamp(2rem, 5vw, 3.4rem);
  line-height: 1.05;
}

.privacy-intro p {
  max-width: 760px;
  margin: 0;
  color: #5d7890;
  font-size: 1.03rem;
  line-height: 1.75;
}

.privacy-intro .privacy-date {
  margin-top: 14px;
  color: #8196a8;
  font-size: 0.86rem;
  font-weight: 700;
}

.privacy-summary {
  margin: 28px 0 38px;
  display: flex;
  flex-wrap: wrap;
  gap: 9px;
}

.privacy-summary a {
  padding: 9px 12px;
  border: 1px solid #dbe6ed;
  border-radius: 10px;
  color: #315978;
  background: #f7fafc;
  font-size: 0.82rem;
  font-weight: 800;
  text-decoration: none;
}

.privacy-card section {
  scroll-margin-top: 24px;
  margin-top: 38px;
}

.privacy-card h2 {
  margin: 0 0 14px;
  color: #17344f;
  font-size: 1.28rem;
}

.privacy-card p,
.privacy-card li {
  color: #526f87;
  font-size: 0.96rem;
  line-height: 1.8;
}

.privacy-card p {
  margin: 0 0 12px;
}

.privacy-card ul {
  margin: 12px 0;
  padding-left: 24px;
}

.privacy-card li + li {
  margin-top: 8px;
}

.privacy-card strong {
  color: #244b6a;
}

.privacy-card a {
  color: #d64f0b;
}

.privacy-contact {
  padding: 24px;
  border: 1px solid rgba(233, 90, 19, 0.18);
  border-radius: 18px;
  background: linear-gradient(135deg, #fff7f2, #f7fafc);
}

.privacy-contact a {
  font-size: 1.02rem;
  font-weight: 900;
}

@media (max-width: 640px) {
  .privacy-page {
    padding: 12px 10px 34px;
  }

  .privacy-header {
    min-height: 64px;
    margin-bottom: 12px;
    padding: 8px 10px;
    border-radius: 16px;
  }

  .privacy-header img {
    width: 122px;
    height: 40px;
  }

  .privacy-home-link {
    padding: 9px 10px;
    font-size: 0.74rem;
  }

  .privacy-card {
    padding: 25px 18px;
    border-radius: 20px;
  }

  .privacy-summary {
    margin-bottom: 30px;
  }

  .privacy-card section {
    margin-top: 31px;
  }

  .privacy-card p,
  .privacy-card li {
    font-size: 0.9rem;
    line-height: 1.72;
  }
}
`, "",{"version":3,"sources":["webpack://./src/mainwebsite/PrivacyPolicy/PrivacyPolicy.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,cAAc;EACd;;;WAGS;AACX;;AAEA;EACE,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,0CAA0C;EAC1C,mBAAmB;EACnB,qCAAqC;EACrC,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,qDAAqD;AACvD;;AAEA;EACE,WAAW;EACX,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,+BAA+B;EAC/B,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,yCAAyC;EACzC,mBAAmB;EACnB,qDAAqD;AACvD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;EACrB;;EAEA;IACE,YAAY;IACZ,YAAY;EACd;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;IAEE,iBAAiB;IACjB,iBAAiB;EACnB;AACF","sourcesContent":[".privacy-page {\n  min-height: 100vh;\n  padding: 24px 20px 64px;\n  color: #17344f;\n  background:\n    radial-gradient(circle at 12% 5%, rgba(233, 90, 19, 0.1), transparent 28%),\n    radial-gradient(circle at 88% 18%, rgba(78, 119, 153, 0.12), transparent 30%),\n    #f6f9fb;\n}\n\n.privacy-header {\n  width: min(1080px, 100%);\n  min-height: 76px;\n  margin: 0 auto 24px;\n  padding: 10px 18px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid rgba(78, 119, 153, 0.16);\n  border-radius: 20px;\n  background: rgba(255, 255, 255, 0.88);\n  box-shadow: 0 14px 38px rgba(23, 52, 79, 0.08);\n  backdrop-filter: blur(18px);\n}\n\n.privacy-header img {\n  display: block;\n  width: 154px;\n  height: 46px;\n  object-fit: contain;\n}\n\n.privacy-home-link {\n  padding: 11px 16px;\n  border-radius: 12px;\n  color: #fff;\n  background: #e95a13;\n  font-size: 0.88rem;\n  font-weight: 800;\n  text-decoration: none;\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.privacy-home-link:hover {\n  color: #fff;\n  transform: translateY(-2px);\n  box-shadow: 0 9px 22px rgba(233, 90, 19, 0.25);\n}\n\n.privacy-card {\n  width: min(960px, 100%);\n  margin: 0 auto;\n  padding: clamp(28px, 5vw, 64px);\n  border: 1px solid rgba(78, 119, 153, 0.14);\n  border-radius: 28px;\n  background: #fff;\n  box-shadow: 0 22px 60px rgba(23, 52, 79, 0.1);\n}\n\n.privacy-intro {\n  padding-bottom: 32px;\n  border-bottom: 1px solid #e1e9ef;\n}\n\n.privacy-kicker {\n  display: inline-flex;\n  margin-bottom: 12px;\n  padding: 7px 11px;\n  border-radius: 999px;\n  color: #c84808;\n  background: #fff0e8;\n  font-size: 0.72rem;\n  font-weight: 900;\n  letter-spacing: 0.1em;\n  text-transform: uppercase;\n}\n\n.privacy-intro h1 {\n  margin: 0 0 16px;\n  color: #112f49;\n  font-size: clamp(2rem, 5vw, 3.4rem);\n  line-height: 1.05;\n}\n\n.privacy-intro p {\n  max-width: 760px;\n  margin: 0;\n  color: #5d7890;\n  font-size: 1.03rem;\n  line-height: 1.75;\n}\n\n.privacy-intro .privacy-date {\n  margin-top: 14px;\n  color: #8196a8;\n  font-size: 0.86rem;\n  font-weight: 700;\n}\n\n.privacy-summary {\n  margin: 28px 0 38px;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 9px;\n}\n\n.privacy-summary a {\n  padding: 9px 12px;\n  border: 1px solid #dbe6ed;\n  border-radius: 10px;\n  color: #315978;\n  background: #f7fafc;\n  font-size: 0.82rem;\n  font-weight: 800;\n  text-decoration: none;\n}\n\n.privacy-card section {\n  scroll-margin-top: 24px;\n  margin-top: 38px;\n}\n\n.privacy-card h2 {\n  margin: 0 0 14px;\n  color: #17344f;\n  font-size: 1.28rem;\n}\n\n.privacy-card p,\n.privacy-card li {\n  color: #526f87;\n  font-size: 0.96rem;\n  line-height: 1.8;\n}\n\n.privacy-card p {\n  margin: 0 0 12px;\n}\n\n.privacy-card ul {\n  margin: 12px 0;\n  padding-left: 24px;\n}\n\n.privacy-card li + li {\n  margin-top: 8px;\n}\n\n.privacy-card strong {\n  color: #244b6a;\n}\n\n.privacy-card a {\n  color: #d64f0b;\n}\n\n.privacy-contact {\n  padding: 24px;\n  border: 1px solid rgba(233, 90, 19, 0.18);\n  border-radius: 18px;\n  background: linear-gradient(135deg, #fff7f2, #f7fafc);\n}\n\n.privacy-contact a {\n  font-size: 1.02rem;\n  font-weight: 900;\n}\n\n@media (max-width: 640px) {\n  .privacy-page {\n    padding: 12px 10px 34px;\n  }\n\n  .privacy-header {\n    min-height: 64px;\n    margin-bottom: 12px;\n    padding: 8px 10px;\n    border-radius: 16px;\n  }\n\n  .privacy-header img {\n    width: 122px;\n    height: 40px;\n  }\n\n  .privacy-home-link {\n    padding: 9px 10px;\n    font-size: 0.74rem;\n  }\n\n  .privacy-card {\n    padding: 25px 18px;\n    border-radius: 20px;\n  }\n\n  .privacy-summary {\n    margin-bottom: 30px;\n  }\n\n  .privacy-card section {\n    margin-top: 31px;\n  }\n\n  .privacy-card p,\n  .privacy-card li {\n    font-size: 0.9rem;\n    line-height: 1.72;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
